<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-05'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Intelligent voice and video services – managing multiple personas with fixed mobile convergence</h2>

                <p>A user can select additional numbers within their subscription and assign them to different profiles like home, work and hobby, enabling them to make voice calls according to the actual profile. Multiple devices can be added to the service, not just the user’s smartphone, but fixed lines, tablets and wearables.</p>
                <p>The service directs incoming calls to multiple numbers to the appropriate device, while outgoing calls are customized with a different number selected from the profile with personalized caller identity.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>